import React from 'react';
import { Divider } from "antd";
import './GraphicStat.css'; // Ensure this CSS file contains the necessary styles

// Custom GraphicStat component
const GraphicStat = ({
  title,
  value,
  imgUrl,
  linearGradient,
  icon,
  overlay = 'rgba(0, 0, 0, 0)',
  backdropFilter='',
  fontSize = '24px',
  width = '240px',
  centerContent = false,
  onClick
}) => {
  const backgroundStyle = imgUrl ? { backgroundImage: `url(${imgUrl})` } : { backgroundImage: linearGradient };
  const isHoverable = !!onClick;

  return (
    <div className={`graphic-stat ${isHoverable?"hover":""}`} style={{ ...backgroundStyle, width }} onClick={onClick}>
      <div className="graphic-stat-content" style={{ background: overlay, backdropFilter }}>
        <div className="graphic-stat-text">
          <div className="graphic-stat-title">{title}</div>
          <div className={`graphic-stat-value my-3 ${centerContent ? 'centered' : ''}`} style={{ fontSize }}>
            {value}
          </div>
        </div>
        {icon && <div className="graphic-stat-icon">{icon}</div>}
      </div>
    </div>
  );
};

export default GraphicStat;
